const propertyResources = {
  en: {
    property: {
      title: 'Property insurance',
      calculator: 'Insurance Calculator',
      object: 'Object cost',
      sum: 'Sum insured',
      period: 'Term of insurance',
      months: ' months',
      date: 'Contract start date',
      warning:
        'There is a limit of 30% of the sum insured for finishing insurance',
      premium: 'Premium',
      premiumPromotion: 'Discounted premium',
      button: 'Calculate',
      'button.next': 'Next',
      'description.title': 'Description',
      'description.text1': 'The sum insured ',
      'description.text2': `for immovable/movable property is established by agreement of the parties in the
      amount of the actual (market) value of the insured object, taking into account the cost of fixture and
      fittings, in the amount of 30% of the insured amount. The maximum insured amount under one Policy
      is 100,000,000 KZT.`,
      'description.text3':
        'Interior finishing of real estate in the amount of 30% of the sum insured is included in the insurance coverage.',
      'description.text4': 'Insurance risks:',
      'description.text5': 'fire, explosion, lightning strike;',
      'description.text6':
        'natural disasters (earthquake, flood, flood, storm, hurricane, tornado, landslide, landslide, rockfall, avalanche, mudflow, hail);',
      'description.text7':
        'causing damage to faulty plumbing, sewerage, heating systems;',
      'description.text8': 'collision, impact (collision of vehicles);',
      'description.text9':
        'illegal actions of third parties, namely theft burglary, robbery, robbery attack',
      'description.text10': 'fall of manned aircraft or parts thereof',
      'description.text11':
        'penetration of water from neighboring premises (apartments, parts of the house), premises alien to the owner of the property.',
      'description.text12': 'Tariff - ',
      'description.text13': '0,15%',
      'description.text14.title': 'The deductible for each and every case is: ',
      'description.text14': `In case of partial damage – 0,3% of the total insured value, minimum 30,000 KZT;
      In case of total loss, fire, explosion and natural disasters - 8% of the total sum insured.`,
      'description.text15': 'Special conditions',
      'description.text16': `If in the Insured's application form, sum insured for the insured object is set in an amount less than its
      actual (market) value, then the insurance claim payment is reduced in proportion to the ratio of the
      insured amount to the market value as a percentage. If the sum insured determined by the Insurance
      Policy exceeds the actual (market) value of the insurance object, the Insurance Policy will not cover
      in that part of the insured amount that exceeds the market value.`,
      'description.text17': 'Exclusions for objects:',
      'description.text18': 'that built before 1960;',
      'description.text19':
        'that has wooden-frame, wooden walls, walls from wooden sleepers;',
      'description.text20': 'that partial destroyed or unfinished;',
      'description.text21':
        'samples, models, prototypes, exhibition items, etc.;',
      'description.text22':
        'paintings, sculptures or other collections and works of art;',
      'description.text23':
        'that part of unfinished objects or under construction in progress, or partly destroyed.',
      'property.programs': 'Property insurance programs',
      'property.description':
        'How we would like to believe that nothing will happen to our home when we create it. The peace of mind for the well-being and comfort, as well as the confidence in tomorrow, will be provided by the property insurance program against any damage.',
      'Покрытие по тарифу': 'Покрытие по тарифу',
      'Внутр. отделка': 'Interior finishes',
      Имущество: 'Property',
      'Выплата соседям': 'Liability to neighbors',
      Франшиза: 'Franchise',
      jusan: {
        'acc1.title': 'What you can insure against',
        'acc1.html': `Fire, explosion, flood, burglary, robbery, robbery, natural disasters (floods,
floods, blizzard, hurricane, tornado, landslide, landslide, rockfall, avalanche,
mudslide, hail)
<br /><br />
Responsibility to neighbors (if the insured floods neighboring apartments)`,

        'acc2.title': 'What insurance covers',
        'acc2.html': `The policy will cover the repair of the interior decoration of the insured
apartment (floor, wall, ceiling coverings, doors, windows, stained glass windows,
interior furniture) and the costs of the affected large household appliances and
electronics
<br /><br />
Compensation for damage to neighbors: if the insured floods the neighbors, the
insurance will compensate them for the repair of the interior decoration of the
apartment`,
        'acc3.title': 'Additional conditions',
        'acc3.html': `<p>The franchise is temporary – 10 calendar days from the date of the Policy
conclusion.</p>`,
      },
      'Страхование квартиры': 'Apartment insurance',
      'Общая сумма страхования': ' Total insurance amount',
      'Страховкой покрывается': 'The insurance covers',
      'Внутренняя отделка': 'Interior finishes',
      Техника: 'Appliances',
      'За ущерб соседям': 'For the damage to the neighbors',
      месяцев: 'months',
      'Имущество плюс': 'Property plus',
      'Сдается в аренду': 'For rent',
      Стоимость: 'Cost',
      Условия: 'Terms',
      'Данные имущества': 'Property details',
      'Данные страхователя': 'Insurer details',
      Подтверждение: 'Confirmation',
      'description.subtitle': `Thick walls, strong doors and reliable locks ensure the safety of housing. But
there are security risks inside the apartment that are difficult to predict – wiring
may flare up, a pipe in the bathroom may burst or flood from above. Your own
apartment and neighbors may be affected. Apartment insurance will help protect
the property of the insured and his neighbors from trouble.`,
      promotionDescription:
        'When signing a Property Plus insurance contract, clients become participants in the spring promotion, the winners of which will receive a certificate for apartment insurance with a payment of up to 4,000,000 tenge or a certificate for a hard hat with an insurance payment of up to 1,000,000 tenge. The promotion runs from March 15 to June 14, 2025',

      bannerFlatJusan: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/prop_2016%D1%85158_ru8.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_343x100_ru8.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_2016%D1%85158_B_ru8.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_343x100_B_ru8.png',
      },
      'Подтвердите, что объект не относится к категориям':
        'Подтвердите, что объект не относится к категориям',
      Подтвердить: 'Подтвердить',
      'принадлежит юридическим лицам;': 'принадлежит юридическим лицам;',
      'находится в аварийном состоянии, в каркасно-камышитовых, деревянных домах;':
        'находится в аварийном состоянии, в каркасно-камышитовых, деревянных домах;',
      'используется не по назначению (не для жилья);':
        'используется не по назначению (не для жилья);',
      'в домах, построенных ранее 1960 года;':
        'в домах, построенных ранее 1960 года;',
      'подлежащие сносу или переоборудованию под нежилые помещения;':
        'подлежащие сносу или переоборудованию под нежилые помещения;',
      'подлежащие отчуждению в связи с изъятием земельного участка, на которые обращено взыскание по обязательствам;':
        'подлежащие отчуждению в связи с изъятием земельного участка, на которые обращено взыскание по обязательствам;',
      'не введенные в эксплуатацию.': 'не введенные в эксплуатацию.',
      'Внимание! Данные вводятся на кириллице (Например: АЛМАТЫ)':
        'Внимание! Данные вводятся на кириллице (Например: АЛМАТЫ)',
      'Регион не найден': 'Регион не найден',
      Регион: 'Регион',
      Город: 'Город',
      'Улица/Микрорайон, номер дома': 'Улица/Микрорайон, номер дома',
      'Номер квартиры': 'Номер квартиры',
      Этаж: 'Этаж',
      'Этажность дома': 'Этажность дома',
      'Год постройки': 'Год постройки',
      'Страхование возможно только для объектов, построенных не ранее 1960 года':
        'Страхование возможно только для объектов, построенных не ранее 1960 года',
      'Страхователь/Застрахованный': 'Страхователь/Застрахованный',
      Выгодоприобретатель: 'Выгодоприобретатель',
      'Страховая сумма': 'Страховая сумма',
      'Страховая премия': 'Страховая премия',
      'Дата начала договора': 'Дата начала договора',
      'Срок страхования': 'Срок страхования',
      '12 месяцев': '12 месяцев',
      'Тип объекта': 'Тип объекта',
      Дом: 'Дом',
      Квартира: 'Квартира',
      'Адрес объекта': 'Адрес объекта',
      Оплатить: 'Оплатить',
    },
  },
  kz: {
    property: {
      title: 'Мүлікті сақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      object: 'Объектінің құны',
      sum: 'Сақтандыру сомасы',
      period: 'Сақтандыру мерзімі',
      months: ' ай',
      date: 'Шарттың басталатын күні',
      warning:
        'Әрлеуді сақтандыруға сақтандыру сомасының 30% мөлшерінде лимит белгіленген',
      premium: 'Сыйақы',
      premiumPromotion: 'Сыйақы жеңілдікпен',
      button: 'Есептеу',
      'button.next': 'Әрі қарай',
      'description.title': 'Сипаттамасы',
      'description.text1': 'Жылжымайтын/жылжымалы мүлiктi сақтандыру сомасы ',
      'description.text2': `тараптардың келiсiмi бойынша әрлеу
      құнын ескере отырып, сақтандыру объектiсiнiң нақты (нарықтық) құны мөлшерiнде
      сақтандыру сомасының 30 %-ы мөлшерiнде белгiленедi. Бір Полис бойынша сақтандырудың
      ең жоғары сомасы 100 000 000 теңгені құрайды`,
      'description.text3':
        'Сақтандыру сомасының 30% мөлшерінде жылжымайтын мүлікті ішкі әрлеу сақтандыру өтеміне енгізіледі.',
      'description.text4': 'Сақтандыру тәуекелдері:',
      'description.text5': 'Өрт, жарылыс, найзағай соққысы;',
      'description.text6':
        'табиғи апаттар (жер сілкінісі, су тасқыны, дауыл, торнадо, көшкін, құлау, тас құлау, қар көшкіні, сел, бұршақ);',
      'description.text7':
        'ақаулы су құбыры, кәріз, жылыту жүйелеріне зиян келтіру;',
      'description.text8': 'соқтығысу, соққы (көлік құралдарының соқтығысуы);',
      'description.text9':
        'үшінші тұлғалардың заңсыз әрекеттері, атап айтқанда бұзып кіріп ұрлау, тонау, қарақшылық шабуыл;',
      'description.text10':
        'басқарылатын ұшу аппараттарының немесе олардың бөліктерінің құлауы',
      'description.text11':
        'көрші үй-жайлардан (пәтерлерден, үйдің бір бөлігінен), үй-жайлардың мүлкінің иесі үшін бөтен адамдардан судың енуі.',
      'description.text12': 'Тариф - ',
      'description.text13': '0,15%',
      'property.programs': 'Мүлікті сақтандыру бағдарламалары',
      'description.text14.title':
        'Әрбір және кез келген жағдай бойынша сөзсіз шегерім: ',
      'description.text14': `залал үшін – сақтандырудың жалпы
        сомасының 0,3%, бірақ 30 000 теңгеден кем емес; Жалпы шығын, өрт, жарылыс және табиғи
        апаттар кезіндегі сақтандыру сомасының 8%`,
      'description.text15': 'Ерекше шарттар',
      'description.text16': `Егер сақтандыру объектісі бойынша сақтандыру сомасы сақтанушының өтініш нысанына
      сәйкес айқындалатын оның нақты (нарықтық) құнынан аз мөлшерде белгіленсе, онда
      сақтандыру төлемі сақтандыру сомасының нарықтық құнына қатынасына пропорционалды
      түрде азайтылады. пайыз ретінде. Сақтандыру полисінде айқындалған сақтандыру сомасы
      сақтандыру объектісінің нақты (нарықтық) құнынан асатын болса, сақтандыру сомасының
      нарықтық құннан асатын бөлігіндегі Сақтандыру полисі жарамсыз болып табылады.`,
      'description.text17': 'Сақтандыруға қабылданбаған объектілер:',
      'description.text18': '1960 жылға дейін салынған;',
      'description.text19': 'каркас-сазды, ағаш, шпальды объекттер;',
      'description.text20':
        'авариялық жағдайдағы, сондай-ақ пайдалануға берілмеген.',
      'description.text21':
        'үлгілер, макеттер, макеттер, тәжірибелік үлгілер, көрме заттары және т.б.;',
      'description.text22':
        'сызбалар, картиналар, мүсіндер немесе басқа коллекциялар мен өнер туындылары;',
      'description.text23':
        'құрылысы аяқталмаған, апатты және тозған жағдайда тұрған объектілердегі мүлік.',
      'property.description':
        'Мен өз үйімді құрастыру кезінде оған ештеңе болмайды деп сенгім келеді. Әл-ауқат пен жайлылық үшін тыныштық, сондай-ақ ертеңгі күнге деген сенімділікті мүлікті зақымданудан сақтандыру бағдарламасы  қамтамасыз етеді.',
      'Покрытие по тарифу': 'Покрытие по тарифу',
      'Внутр. отделка': 'Ішкі әрлеу',
      Имущество: 'Мүлік',
      'Выплата соседям': 'Көршілерге төлем',
      Франшиза: 'Франшиза',
      jusan: {
        'acc1.title': 'Неден сақтандыруға болады',
        'acc1.html': `Өрттен, жарылыстан, су басудан, бұзып ұрлаудан, тонаудан,
қарақшылықтан, табиғи апаттардан (су тасқыны, су басу, боран, дауыл,
қара құйын, көшкін, опырылу, тас құлау, қар көшкіні, сел, бұршақ)
<br /><br />
Көршілер алдындағы жауапкершілік (егер сақтандырылушыдан көрші
пәтерлерге су өтсе)`,
        'acc2.title': 'Сақтандыру нені қамтиды',
        'acc2.html': `Полис сақтандырылған пәтердің ішкі безендірілуін (еден, қабырға, төбе
жабындарын, есіктерді, терезелерді, витраждарды, ішкі жиһаздарды) және
зақымдалған ірі тұрмыстық техника мен электроника шығыстарын өтейді
Көршілерге келтірілген залалды өтеу: егер сақтандырылушыдан
көршілеріне су өтсе, сақтандыру оларға пәтердің ішкі безендірілуін
жөндеуді өтейді`,
        'acc3.title': 'Қосымша талаптар',
        'acc3.html': `<p>Уақытша франшиза - Полис жасалған күннен бастап күнтізбелік 10 күн.</p>`,
      },
      'Страхование квартиры': 'Пәтерді сақтандыру',
      'Общая сумма страхования': 'Сақтандырудың жалпы сомасы',
      'Страховкой покрывается': 'Сақтандыру мыналарды қамтиды',
      'Внутренняя отделка': 'Ішкі әрлеу',
      Техника: 'Техника',
      'За ущерб соседям': 'Көршілерге келтірілген зиян үшін',
      месяцев: 'ай',
      'Имущество плюс': 'Мүлік плюс',
      'Сдается в аренду': 'Жалға беріледі',
      Стоимость: 'Бағасы',
      Условия: 'Шарттар',
      'Данные имущества': 'Мүлік мәліметтері',
      'Данные страхователя': 'Сақтанушы',
      Подтверждение: 'Растау',
      'description.subtitle': `Тұрғын үйдің қауіпсіздігін қалың қабырғалар, берік есіктер және сенімді
құлыптар қамтамасыз етеді. Бірақ пәтердің ішінде алдын-ала болжау қиын
болатын қауіпсіздік тәуекелдері бар - сымдар жүйесі тұтанып, жуынатын
бөлмедегі құбырлар жарылуы немесе жоғарыдан су басуы мүмкін. Өз
пәтеріңізбен қатар, көршілеріңіз де зардап шегуі мүмкін. Пәтерді
сақтандыру сақтандырылушының және оның көршілерінің мүлкін
жайсыздықтардан қорғауға көмектеседі.`,

      promotionDescription:
        'Мүлік плюс сақтандыру шартын ресімдеу кезінде клиенттер көктемгі акцияға қатысушы бола алады, оның жеңімпаздары 4 000 000 теңгеге дейін төленетін пәтерді сақтандыруға сертификат немесе 1 000 000 теңгеге дейін сақтандыру төлемі бар каскоға сертификат алады. Акция 2025 жылдың 15 наурызы мен 14 маусымы аралығында өтеді.',

      bannerFlatJusan: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/prop_2016%D1%85158_kz8.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_343x100_kz8.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_2016%D1%85158_B_kz8.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_343x100_B_kz8.png',
      },
      'Подтвердите, что объект не относится к категориям':
        'Объектінің төмендегі санаттарға жатпайтынын растаңыз',
      Подтвердить: 'Растау',
      'принадлежит юридическим лицам;': 'заңды тұлғаларға тиесілі;',
      'находится в аварийном состоянии, в каркасно-камышитовых, деревянных домах;':
        'апатты жағдайда, қаңқалы-қамысты, ағаш үйлерде;',
      'используется не по назначению (не для жилья);':
        'мақсатсыз пайдаланылады (тұрғын үй үшін емес);',
      'в домах, построенных ранее 1960 года;':
        '1960 жылдан бұрын салынған үйлерде;',
      'подлежащие сносу или переоборудованию под нежилые помещения;':
        'бұзуға немесе тұрғын емес үй-жайларға айналдыруға жататын;',
      'подлежащие отчуждению в связи с изъятием земельного участка, на которые обращено взыскание по обязательствам;':
        'міндеттемелер бойынша өндіріп алынған жер учаскесін алып қоюға байланысты иеліктен шығаруға жататындар;',
      'не введенные в эксплуатацию.': 'пайдалануға берілмеген.',
      'Внимание! Данные вводятся на кириллице (Например: АЛМАТЫ)':
        'Назар аударыңыз! Деректер кириллицаға енгізіледі (мысалы: АЛМАТЫ)',
      'Регион не найден': 'Аймақ табылмады',
      Регион: 'Аймақ',
      Город: 'Қала',
      'Улица/Микрорайон, номер дома': 'Көше / шағын аудан, үй нөмірі',
      'Номер квартиры': 'Пәтер нөмірі',
      Этаж: 'Қабат',
      'Этажность дома': 'Үйдің қабаты',
      'Год постройки': 'Салынған жылы',
      'Страхование возможно только для объектов, построенных не ранее 1960 года':
        'Сақтандыру тек 1960 жылдан ерте салынбаған нысандар үшін мүмкін',
      'Страхователь/Застрахованный': 'Сақтанушы / Сақтандырылған',
      Выгодоприобретатель: 'Пайда алушы',
      'Страховая сумма': 'Сақтандыру сомасы',
      'Страховая премия': 'Сақтандыру сыйлықақысы',
      'Дата начала договора': 'Шарттың басталу күні',
      'Срок страхования': 'Сақтандыру мерзімі',
      '12 месяцев': '12 ай',
      'Тип объекта': 'Нысан түрі',
      Дом: 'Үй',
      Квартира: 'Пәтер',
      'Адрес объекта': 'Объектінің мекенжайы',
      Оплатить: 'Төлеу',
    },
  },
  ru: {
    property: {
      title: 'Страхование имущества',
      calculator: 'Калькулятор страхования',
      object: 'Стоимость объекта',
      sum: 'Сумма страхования',
      period: 'Срок страхования',
      months: ' месяцев',
      date: 'Дата начала договора',
      warning:
        'На страхование отделки установлен лимит в размере 30% от страховой суммы',
      premium: 'Премия',
      premiumPromotion: 'Премия со скидкой',
      button: 'Рассчитать',
      'button.next': 'Далее',
      'description.title': 'Описание',
      'description.text1': 'Страховая сумма ',
      'description.text2': `по недвижимому/движимому имуществу устанавливается по соглашению
      сторон в размере действительной (рыночной) стоимости страхуемого объекта с учетом
      стоимости отделки, в размере 30% от страховой суммы. Максимальная страховая сумма по
      одному Полису составляет 100 000 000 тенге.`,
      'description.text3':
        'Внутренняя отделка недвижимости в размере 30% от страховой суммы включается в страховое покрытие.',
      'description.text4': 'Страховые риски:',
      'description.text5': 'пожар,взрыв,удар молнии;',
      'description.text6':
        'стихийные бедствия (землетрясение, наводнение, затопление, буря, ураган, смерч, оползень, обвал, камнепад, лавина, сель, град);',
      'description.text7':
        'нанесение ущерба неисправной водопроводной, канализационной, отопительной системами;',
      'description.text8': 'столкновение,удар (наезд транспортных средств);',
      'description.text9':
        'противоправные действия третьих лиц,а именно кражи со взломом, грабежа, разбои;',
      'description.text10':
        'падение пилотируемых летальных аппаратов или их частей',
      'description.text11':
        'проникновение воды из соседних помещений (квартир, части дома), чужих для владельца имущества помещений.',
      'description.text12': 'Тариф - ',
      'description.text13': '0,15%',
      'description.text14.title': 'Безусловная франшиза ',
      'description.text14':
        'по каждому и любому случаю составляет: по ущербу - 0,3% от общей страховой суммы, но не менее 30 000 тенге; 8% от общей страховой суммы при полной гибели, пожаре, взрыве и стихийных бедствиях.',
      'description.text15': 'Особые условия',
      'description.text16': `Если страховая сумма по объекту страхования установлена в размере меньшем, чем его
        действительная (рыночная) стоимость, определенная согласно заявлению-анкете
        Страхователя, то страховая выплата уменьшается пропорционально отношению таковой
        страховой суммы к рыночной стоимости в процентном соотношении. Если страховая сумма,
        определенная Полисом страхования, превышает действительную (рыночную) стоимость
        объекта страхования, Полис страхования в той части страховой суммы, которая превышает
        рыночную стоимость является недействительной.`,
      'description.text17': 'Не принимаются на страхование объекты:',
      'description.text18': 'ранее 1960 года постройки;',
      'description.text19':
        'каркасно-камышитовые, деревянные, шпальные объекты;',
      'description.text20':
        'находящиеся в аварийном состоянии, а также не введенные в эксплуатацию.',
      'description.text21':
        'образцы, модели, макеты, прототипы, выставочные экземпляры и т.п.;',
      'description.text22':
        'рисунки, картины, скульптуры или другие коллекции и произведения искусства;',
      'description.text23':
        'имущество, содержащееся в объектах, находящихся в стадии незавершенного строительства, в аварийном и ветхом состоянии.',
      'property.programs': 'Программы страхования имущества',
      'property.description':
        'Как хочется верить, что создавая свой дом с ним ничего не произойдет. Спокойствие за благополучие и уют, а так же уверенность в завтрашнем дне обеспечит программа страхования имущества от ущерба.',
      'Покрытие по тарифу': 'Покрытие по тарифу',
      'Внутр. отделка': 'Внутр. отделка',
      Имущество: 'Имущество',
      'Выплата соседям': 'Выплата соседям',
      Франшиза: 'Франшиза',
      jusan: {
        'acc1.title': 'От чего можно застраховаться',
        'acc1.html': `Пожар, взрыв, потоп, кража со взломом, грабеж, разбой, стихийные
бедствия (наводнения, затопления, буран, ураган, смерч, оползень, обвал,
камнепад, лавины, сель, град)
<br/><br/>
Ответственность перед соседями (если застрахованный затопит соседние
квартиры)`,
        'acc2.title': 'Что покрывает страховка',
        'acc2.html': `
        Полис покроет ремонт внутренней отделки застрахованной квартиры
(напольное, настенное, потолочное покрытия, двери, окна, витражи,
внутренняя мебель) и затраты на пострадавшую крупную бытовую
технику и электронику
<br/><br/>
Возмещение ущерба соседям: если застрахованный затопит соседей,
страховка компенсирует им ремонт внутренней отделки квартиры`,
        'acc3.title': 'Дополнительные условия',
        'acc3.html': `<p>Франшиза временная – 10 календарных дней с даты заключения Полиса.</p>`,
      },
      'Страхование квартиры': 'Страхование квартиры',
      'Общая сумма страхования': 'Общая сумма страхования',
      'Страховкой покрывается': 'Страховкой покрывается',
      'Внутренняя отделка': 'Внутренняя отделка',
      Техника: 'Техника',
      'За ущерб соседям': 'За ущерб соседям',
      месяцев: 'месяцев',
      'Имущество плюс': 'Имущество плюс',
      'Сдается в аренду': 'Сдается в аренду',
      Стоимость: 'Стоимость',
      Условия: 'Условия',
      'Данные имущества': 'Данные имущества',
      'Данные страхователя': 'Данные страхователя',
      Подтверждение: 'Подтверждение',
      'description.subtitle':
        'Безопасность жилья обеспечивают толстые стены, крепкие двери и надежные замки, но есть риски безопасности внутри квартиры, которые сложно предугадать – может вспыхнуть проводка, прорвать трубу в ванной или затопить сверху, пострадать может собственная квартира и соседи, страхование квартиры поможет защитить имущество застрахованного и его соседей от неприятностей.',
      promotionDescription:
        'При оформлении договора страхования Имущество плюс клиенты становятся участниками весенней акции, победители которой получат сертификат на страховку квартиры с выплатой до 4 000 000 тенге или сертификат на каско со страховой выплатой до 1 000 000 тенге. Акция проходит с 15 марта по 14 июня 2025 года.',
      bannerFlatJusan: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/prop_2016%D1%85158_ru8.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_343x100_ru8.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_2016%D1%85158_B_ru8.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/prop_343x100_B_ru8.png',
      },
      'Подтвердите, что объект не относится к категориям':
        'Подтвердите, что объект не относится к категориям',
      Подтвердить: 'Подтвердить',
      'принадлежит юридическим лицам;': 'принадлежит юридическим лицам;',
      'находится в аварийном состоянии, в каркасно-камышитовых, деревянных домах;':
        'находится в аварийном состоянии, в каркасно-камышитовых, деревянных домах;',
      'используется не по назначению (не для жилья);':
        'используется не по назначению (не для жилья);',
      'в домах, построенных ранее 1960 года;':
        'в домах, построенных ранее 1960 года;',
      'подлежащие сносу или переоборудованию под нежилые помещения;':
        'подлежащие сносу или переоборудованию под нежилые помещения;',
      'подлежащие отчуждению в связи с изъятием земельного участка, на которые обращено взыскание по обязательствам;':
        'подлежащие отчуждению в связи с изъятием земельного участка, на которые обращено взыскание по обязательствам;',
      'не введенные в эксплуатацию.': 'не введенные в эксплуатацию.',
      'Внимание! Данные вводятся на кириллице (Например: АЛМАТЫ)':
        'Внимание! Данные вводятся на кириллице (Например: АЛМАТЫ)',
      'Регион не найден': 'Регион не найден',
      Регион: 'Регион',
      Город: 'Город',
      'Улица/Микрорайон, номер дома': 'Улица/Микрорайон, номер дома',
      'Номер квартиры': 'Номер квартиры',
      Этаж: 'Этаж',
      'Этажность дома': 'Этажность дома',
      'Год постройки': 'Год постройки',
      'Страхование возможно только для объектов, построенных не ранее 1960 года':
        'Страхование возможно только для объектов, построенных не ранее 1960 года',
      'Страхователь/Застрахованный': 'Страхователь/Застрахованный',
      Выгодоприобретатель: 'Выгодоприобретатель',
      'Страховая сумма': 'Страховая сумма',
      'Страховая премия': 'Страховая премия',
      'Дата начала договора': 'Дата начала договора',
      'Срок страхования': 'Срок страхования',
      '12 месяцев': '12 месяцев',
      'Тип объекта': 'Тип объекта',
      Дом: 'Дом',
      Квартира: 'Квартира',
      'Адрес объекта': 'Адрес объекта',
      Оплатить: 'Оплатить',
    },
  },
};

export default propertyResources;
